<template>
  <div>
    <div
      class="flex flex-wrap"
      v-for="(child, index) in previewData"
      :key="index"
    >
      <div class="flex flex-grow place-items-start">
        <div class="flex-1 flex flex-col mr-2 ml-2">
          <p class="mr-auto inline">
            Active version <span class="font-bold ">{{ child.versionId }}</span>
          </p>
          <div
            class="m-auto w-full"
            v-if="child.left.preview"
            :key="`left-image-${index}`"
          >
            <preview-image
              :current-preview="child.left.preview"
              @click="setSelectedImage(child.left.preview)"
            />
          </div>
        </div>
        <div class="flex-1 flex flex-col mr-2">
          <p class="inline right-0">New version</p>
          <div class="" v-if="child.right" :key="`right-image-${index}`">
            <preview-image
              v-if="child.right.preview"
              :current-preview="child.right.preview"
              @click="setSelectedImage(child.right.preview)"
            />
            <p v-else>Preview of new version unavailable</p>
          </div>
        </div>
      </div>

      <div
        class="flex-3 flex-grow"
        v-if="child.diff"
        :key="`diff-image-${index}`"
      >
        <div class="w-1/2 m-auto">
          <p>Comparison</p>
          <preview-image
            v-if="child.diff.preview"
            :current-preview="child.diff.preview"
            @click="setSelectedImage(child.diff.preview)"
          />
          <p v-else>Preview of diff unavailable</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewImage from "components/PreviewImage";

export default {
  components: {
    PreviewImage,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    previewData() {
      return this.data;
    },
  },
  methods: {
    setSelectedImage(data) {
      this.$emit("openPreview", data);
    },
  },
};
</script>
